<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <vuestic-widget>
          <vuestic-data-table
            ref="table"
            :apiUrl="getApiUrl"
            :tableFields="tableFields"
            :itemsPerPage="itemsPerPage"
            :defaultPerPage="defaultTablePerPage"
            :sortFunctions="sortFunctions"
            :apiMode="apiMode"
            :paginationPath="paginationPath"
            :queryParams="queryParams"
            :saleType="saleType"
            :setSaleType="setSaleType"
            :setDueDate="setDueDate"
            :currentDueDate="currentDueDate"
            :filterInputLabel="'Search...'"
          />
        </vuestic-widget>
      </div>
    </div>
    <vuestic-modal :show.sync="show" v-bind:large="true" ref="ItemsModal"
                   :cancelText="'Hide'"  :okClass="'none'" @cancel="onCancel()">
      <template v-if="currentItemsOrders">
        <div slot="title">
          {{currentItemsOrders.address}}
        </div>
        <vuestic-tree-root>
          <template v-for="(item, index) in currentItemsOrders.data">
            <vuestic-tree-category isOpen :label="item.description" class="text-auto" :class="{'text-bold': item.side == 4, 'text-red': item.side == -1}" v-if="item.children" v-bind:key="index">
              <vuestic-tree-node v-for="(child, index) in item.children" class="text-auto" :class="{'text-red': child.side == -1}" v-bind:key="index">{{child.description}}</vuestic-tree-node>
            </vuestic-tree-category>
            <vuestic-tree-node v-else v-bind:key="index" class="text-auto" :class="{'text-red': item.side == -1}">{{item.description}}</vuestic-tree-node>
          </template>
        </vuestic-tree-root>
      </template>
    </vuestic-modal>
    <vuestic-modal :show.sync="show" v-bind:large="true" ref="MapModal"
                   :cancelText="'Hide'" :okClass="'none'" @cancel="onCancelMap()">
      <template v-if="currentMap">
        <div slot="title">
          Tracker - <a :href="currentMap">{{ currentMap }}</a>
        </div>
        <div>
          <iframe :src="currentMap" width="100%" height="700px" frameborder="0"></iframe>
        </div>
      </template>
    </vuestic-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import ItemsPicker from './ItemsPicker.vue'
  import MapPicker from './MapPicker.vue'
  import FieldsDef from 'vuestic-components/vuestic-datatable/data/fields-definition'
  import QueryParams from 'vuestic-components/vuestic-datatable/data/query-params'

  Vue.component('items-picker', ItemsPicker)
  Vue.component('map-picker', MapPicker)

  export default {
    name: 'Table',
    computed: {
      ...mapGetters([
        'saleType',
        'currentItemsOrders',
        'currentDueDate',
        'currentMap'
      ]),
      getApiUrl: function () {
        return `${this.chainHash ? '/' + this.chainHash : ''}/orders?type=${this.saleType}&due_date=${this.currentDueDate}`
      },
    },
    watch: {
      currentItemsOrders: function (newVal, oldVal) {
        if (newVal) {
          this.showItemsModal()
        }
      },
      currentMap: function (newVal, oldVal) {
        if (newVal) {
          this.showMapModal()
        }
      }
    },
    mounted: function () {
      const hash = /^\/([a-zA-Z0-9]{32})\//g.exec(location.pathname)
      if (hash) {
        this.chainHash = hash[1]
      }
      if (this.$route.query.refresh) {
        this.intID = setInterval(() => {
          this.$refs.table.refreshData()
        }, this.$route.query.refresh * 1000)
      }
    },
    destroyed: function () {
      if (this.intID) {
        clearInterval(this.intID)
      }
    },
    methods: {
      ...mapMutations([
        'setSaleType',
        'setDueDate'
      ]),
      ...mapActions([
        'setCurrentItems',
        'setCurrentMap'
      ]),
      onCancel () {
        this.setCurrentItems(null)
      },
      onCancelMap () {
        this.setCurrentMap(null)
      },
      showItemsModal () {
        this.$refs.ItemsModal.open()
      },
      showMapModal () {
        this.$refs.MapModal.open()
      }
    },
    data () {
      return {
        chainHash: '',
        intID: 0,
        show: true,
        apiUrl: /^\/[a-zA-Z0-9]{32}\//g.test(location.pathname) ? '' : '/orders?type=1',
        apiMode: true,
        tableFields: FieldsDef.tableFields,
        itemsPerPage: [
          {
            value: 15
          },
          {
            value: 20
          },
          {
            value: 25
          }
        ],
        sortFunctions: FieldsDef.sortFunctions,
        paginationPath: '',
        defaultTablePerPage: 20,
        queryParams: QueryParams
      }
    }
  }
</script>

<style lang="scss">

  .color-icon-label-table {
    td:first-child {
      width: 1rem;
    }
  }

  .text-red {
    color: #cc0000
  }

  .text-auto {
    font-weight: normal
  }

  .text-auto.text-bold {
    font-weight: bold
  }

</style>



// WEBPACK FOOTER //
// src/components/tables/Table.vue